import moment from 'moment-timezone';
import { AccountBucketInfo, CodatCompanyRes, CompanyRes, DisconnectionMgmtCompanyRes } from "../stores/company/company-state";
import CONSTANTS from "./constants";

export const windowRedirectTo: any = (path: any) => {
  return (window.location.href = path);
};

export const isEmpty = (obj: object): boolean => {
  return !obj || Object.keys(obj).length === 0;
};

export const isNotEmpty = (obj: object): boolean => {
  return !isEmpty(obj);
};

export const capitalizeFirstLetter = (name: string) => {
  return name.charAt(0).toUpperCase() + name.slice(1);
};


// TODO: needs tests
export const sortStringsNumericallyThenAlphabetically = (items): string[] => {
  return items.sort((a, b) => {
    const numA = parseInt(a, 10);
    const numB = parseInt(b, 10);

    const isANumeric = !isNaN(numA) && a.trim() === numA.toString();
    const isBNumeric = !isNaN(numB) && b.trim() === numB.toString();

    // If both are numeric, compare numerically
    if (isANumeric && isBNumeric) {
      return numA - numB;
    }

    // If only a is numeric, it should come first
    if (isANumeric) {
      return -1; // a comes before b
    }

    // If only b is numeric, it should come first
    if (isBNumeric) {
      return 1; // b comes before a
    }

    // If both are alphanumeric, compare numerically first, then alphabetically
    const numericPartA = numA;
    const numericPartB = numB;

    if (numericPartA !== numericPartB) {
      return numericPartA - numericPartB; // Numeric comparison
    } else {
      return a.localeCompare(b); // Alphabetical comparison if numeric parts are equal
    }
  });
};

export const filterSubField = (subFieldKey, ignorableSubFields, parentValues) => {
  if (ignorableSubFields[subFieldKey]) {
    const subFieldLookup = ignorableSubFields[subFieldKey];
    // Check the parent value, if the current value matches our ignorable value, skip this field (i.e return false)
    return parentValues[subFieldLookup.parentKey] !== subFieldLookup.parentValue;
  }
  // A normal field, don't filter it out
  else {
    return true;
  }
};

export const getDataGroupBlankFieldCount = (formValues, ignorableFields): number => {
  if (formValues.length == 0 || formValues[0].length < 1) {
    return 0;
  }

  const dataGroup = formValues[0][0];
  if (!dataGroup.includes("dataGroup_") || !dataGroup.includes("topInstitutionalShareholders")) {
    return 0;
  }

  const dataGroupFields = Object.values(formValues[0][1]);
  const blankFieldCount = dataGroupFields.reduce((acc: number, field) => {
    const count = Object.entries(field)
        .filter((entry) => !entry[1])
        .filter((entry) => !ignorableFields.includes(entry[0])).length;
    return acc + count;
  }, 0) as number;

  return blankFieldCount;
};

export const checkOtherErrors = (taskName: string, formValues: any) => {
  let count = 0;

  if(taskName == "Fundraising") {
    formValues.map(field => {
      const fieldValue = parseInt(field[1])
      if(field[0] == "totalAmountRaisedToDate" ) {
        if(fieldValue != undefined && (fieldValue < 1000000 || fieldValue > 1000000000)) {
          count++;
        }
      }

      if(field[0] == "amountRaisedInLastRound") {
        if(fieldValue != undefined && (fieldValue < 0 || fieldValue > 1000000000)) {
          count++;
        }
      }
    })
  }

  return count;
}

export const toUrlSlug = (pathSegment) => {
  if (!pathSegment || pathSegment === "") {
    return "";
  }
  return pathSegment.toLowerCase().trim().replaceAll(" ", "-");
};

export const formatAmount = (amount: number, decimals: 0 | 2 = 0): string => amount.toFixed(decimals).replace(/((\d)(?=(\d{3})+(?!\d+)))/g, "$1,");

export const formatCurrency = (amount: number, decimals: 0 | 2 = 0, signDisplay = false) =>
{
  const amt = parseFloat(amount.toFixed(decimals));

  let  retVal = new Intl.NumberFormat('en-US',
      {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: decimals,
        ...signDisplay && ({signDisplay: "exceptZero"})
      }
  ).format(amt)

  return retVal
}

export const formatPercentage = (amount: number, decimals: 0 | 1 | 2 = 0, signDisplay = false) =>
{
  let  retVal = new Intl.NumberFormat('en-US',
      {
        style: 'percent',
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
         ...signDisplay && ({signDisplay: "exceptZero"})
      }
  ).format(amount)

  return retVal
}





export function isOptionalField(fieldName: string): boolean {
  return CONSTANTS.IGNORABLE_FIELDS.includes(fieldName);
}

export function applyThrottle(callBack: (...args) => void, delay: number) {
  let canProceed = true;
  return (...args) => {
    if (canProceed) {
      canProceed = false;
      callBack(...args);
      setTimeout(() => {
        canProceed = true;
      }, delay);
    }
  };
}

export const formatHelpText = (value) => {
  if (value && value.includes("##")) {
    const parts = value?.split("##");
    return `${parts[0]} <a target="_blank" style="color:white;text-decoration:underline" href=${parts[2]}>${parts[1]}</a>`;
  }

  return value;
};

export const getInitialBucketIdAndLabel = (sourceMapping: any[]) => {
  const newBucketIdAndLabel = new Map();
  sourceMapping.forEach(({ accounts }) => {
    accounts.forEach(({ id, label, idUpdated, labelUpdated, accountId }) => {
      let value;
      if (idUpdated !== "" && labelUpdated !== "") value = `${idUpdated} - ${labelUpdated}`;
      else if (id !== "" && label !== "") value = `${id} - ${label}`;
      else value = "";
      newBucketIdAndLabel.set(accountId, {
        isChanged: idUpdated !== "",
        value,
      });
    });
  });
  return newBucketIdAndLabel;
};

export const getUnBucketedAccountsMap = (sourceMapping: any[]) => {
  const unBucketedAccountsMap = new Map();
  const unBucketedAccounts = sourceMapping.find((item: any) => item.id === "" || item.label === "");

  unBucketedAccounts?.accounts.forEach(({ accountId }) => {
    unBucketedAccountsMap.set(accountId, "");
  });

  return unBucketedAccountsMap;
};


export const isWorkbookRefreshRequired = (newBucketIdAndLabel: Map<string, { isChanged: boolean; value: string }>) => {
  for (const [key, value] of newBucketIdAndLabel) {
    if (value.isChanged) {
      return true;
    }
  }

  return false;
};

export const getCurrentDate = () => {
  const now = new Date();
  const date = now.toLocaleDateString("en-US", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "short",
    day: "numeric",
  });
  const time = now.toLocaleTimeString("en-US", {
    timeZone: "America/Los_Angeles",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  return `${date} ${time} PT`;
};

export const filterByAccounts = (sourceMappings: any[], accountBucketInfo: AccountBucketInfo) => (value: string) => {

  const cloneSourceMappings = structuredClone(sourceMappings);
  const inputValue = value?.toLowerCase();
  const verify = (account) => {
    const { accountId, accountName , fullyQualifiedCategory } = account;
    const { value } = accountBucketInfo.get(accountId);
    const [, creditLensId, creditLensLabel] = value?.match(/^(\w+)\s-\s(.*)$/) ?? [];
    return  creditLensId?.includes(inputValue) || creditLensLabel?.toLowerCase().includes(inputValue) ||  accountName?.toLowerCase().includes(inputValue) ||  accountId?.toLowerCase().includes(inputValue) ||  fullyQualifiedCategory?.toLowerCase().includes(inputValue);
  };

  return cloneSourceMappings.filter((obj) => {
    if (obj.accounts.some((account) => verify(account))) {
      obj.accounts = obj.accounts.filter((account) => verify(account));
      return true;
    }
    return false;
  });
};
 

export const getFilteredCompaniesBySelectedPills = (selectedLabels , companiesByHiddenStatus)=>{

        const filteredRows = companiesByHiddenStatus.filter((row) => {

        if (selectedLabels.has(CONSTANTS.WATCHLIST.ISSUES.CONNECTION_ISSUES)){
            if(!(row?.codatConnectionStatus !== "Linked") ){
              return false
            }
        }

        if (selectedLabels.has(CONSTANTS.WATCHLIST.ISSUES.MISSING_WORKBOOK)){
            if(!(row?.workbookStatus !== "Generated") ){
              return false
            }
        }

        if (selectedLabels.has(CONSTANTS.WATCHLIST.ISSUES.UNBUCKETED_ACCOUNTS) ){
            if(!(row?.unResolvedAccounts && row?.unResolvedAccounts !== "0") ){
              return false
            }
        }

        if (selectedLabels.has(CONSTANTS.WATCHLIST.ISSUES.BOOKS_CLOSURE) ){
            if(!(["HIGH", "MEDIUM"].includes(row?.bookClosureStatus) ) ){
              return false
            }
        }
       

        return true;
      });

      return filteredRows
}

export  const filterCompanyByTeamCode = (row,isApplyTeamCodeFilterIncluded,isMyPortfolio,userTeamCodes)=> {
          let matchesTeamCode = (isApplyTeamCodeFilterIncluded || isMyPortfolio)
        ?  userTeamCodes.includes(row.teamCode)
        : true;

      matchesTeamCode = (!isApplyTeamCodeFilterIncluded && isMyPortfolio) ? false : matchesTeamCode;
      return matchesTeamCode
  }

export const filterCompanyInPortfolio = (row,isMyPortfolio) => {
  return isMyPortfolio && row?.isAddedToPortfolio;
}

export const filterCompanyByHiddenStatus = (row,ishHiddenStatusFilterOn) => {
  return ishHiddenStatusFilterOn && row?.hidden;
}

/** @deprecated Since 1.2.7.
 * Since the disconnection management is utilizing the codat connection details from xavier.
 * - This function used to extract the connectionStatus from codat companies and merge them into action required/actioned company properties.
 * @param codatCompanies
 * @param disconnectionMgmtCompanyRes
 * @returns companies along with connectionStatus.
 */
export const addCodatStatusToDisconnectionMgmtCompanies = (codatCompanies: CodatCompanyRes, DisconnectionMgmtCompanies: DisconnectionMgmtCompanyRes) => {
  const cloneCodatCompanies = structuredClone(codatCompanies);
  const cloneDisconnectionMgmtCompanies = structuredClone(DisconnectionMgmtCompanies);
  const result = cloneDisconnectionMgmtCompanies?.map((company) => {
    const companyInfo = cloneCodatCompanies?.results?.find((codatCompany) => codatCompany.id === company.codat_company_id);
    return {
      ...company,
      codat_connection:  (companyInfo?.dataConnections?.[0]?.status ?? ""),
      connection_ids: companyInfo?.dataConnections?.map(dc => dc.id) ?? []
    };
  });
  return result;
};

export const isActiveCompany = (companyDetails: any) => companyDetails?.status !== 'inactive';

export const isInActiveCompany = (companyDetails: any) => !isActiveCompany(companyDetails);

export function formatPhoneNumber(n: string): string {
  if (n === undefined || n === null) return '';

  if (n.length === 7)
    return n.slice(0,3) + '-' + n.slice(3);

  if (n.length === 10)
    return '(' + n.slice(0,3) + ') ' + formatPhoneNumber(n.slice(3));

  if (n.length === 11)
    return '+' + n.slice(0,1) + ' ' + formatPhoneNumber(n.slice(1));

  return n;
}

export const formatConnectionSource = (connectionSource: string) => {
  let formattedConnectionSource = '';
  switch (connectionSource) {
    case "i2c":
      formattedConnectionSource = "ADF";
      break;
    case "manual":
      formattedConnectionSource = "Manual";
      break;
    default:
      formattedConnectionSource = "DLA";
  }

  return formattedConnectionSource;
}

export const removeSpecialCharsAndSpaces = (str: string) => {
  return str.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
}

export const prepareAccounts = (creditlensCategoryRollup: any[]) => {
  const accountMap = new Map<string, any>();

  let counter = 1;
  creditlensCategoryRollup.forEach((c) => {
    const alias = c.display_name_alias;

    if (alias === 'total_net_profit') {
      if (!accountMap.has(alias)) {
        accountMap.set(alias, {
          id: counter++,
          name: c.display_name || "Total Net Profit",
          key: alias,
          tooltipPairs: ['Total Net Profit comes directly from P&L']
        });
      }
      return;
    }

    if (!accountMap.has(alias)) {
      accountMap.set(alias, {
        id: counter++,
        name: c.display_name,
        key: alias,
        tooltipPairs: [`${c.creditlens_id} - ${c.creditlens_label}`]
      });
    } else {
      accountMap.get(alias).tooltipPairs.push(`${c.creditlens_id} - ${c.creditlens_label}`);
    }
  });

  return Array.from(accountMap.values());
};

export const formatDate = (value: string, format = "MMM DD YYYY", timeZone = "America/Los_Angeles") => {
  return isEmpty(value as any) ? '-' : moment(value).tz(timeZone).format(format);
}